import React, { useReducer } from "react";
import { Form, Header, InputProps, CheckboxProps, Button } from "semantic-ui-react";
import styled from "styled-components";
import { validateEmail } from "../helpers/utils";
import { useUserActions } from "../components/Layout";

const ToolkitFormContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 5em auto;
  border: 2px solid #FAB60B;
  padding: 30px;

  .toolkitForm {
    .ui.input{
      input{
        background-color: transparent;
        border: 3px solid #FAB60B;
        ::placeholder {
          color: #FAB60B;
          opacity: 1; 
        }
        :-ms-input-placeholder {
          color: #FAB60B;
        }
        ::-ms-input-placeholder {
          color: #FAB60B;
        }
      }
    }
  }

  .formSectionTitle{
    text-align: center;
    @media(min-width: 768px){
      padding-top: 2em;
      padding-bottom: .5em;
    }
  }

  .positionFields{
    .ui.radio.checkbox{
      border: 3px solid #FAB60B;
      width: 100%;
      padding: 10px 20px;
      &.checked{
        background-color: #FAB60B;
        label {
          font-weight: bold;
          color: #fff;
        }
      }

      label {
        text-align: center;
        font-size: 1.2em;
        padding-left: 0px;
        &:before{
          display: none;
        }
        &:after{
          display: none;
        }
      }
    }
  }

  .signUpFields{
    text-align: right;
    margin-top: 3em;
    margin-bottom: 5em;
    p {
      text-align: center;
    }
    .ui.radio.checkbox label {
      padding-left: 0px;
      padding-right: 1.85714em;
      &:before{
        top: -2px;
        left: auto;
        right: 0px;
        border: 3px solid #FAB60B;
        width: 20px;
        height: 20px;
      }
      &:after{
        top: 0px;
        left: auto;
        right: 2px;
        width: 16px;
        height: 16px;
      }
    }
  }

  .submitBtn{
    .ui.button{
      margin: auto;
      display: block;
      color: #000;
      background-color: #FAB60B;
    }
  }

`;

interface ToolkitFormProps {  
  onSubmitHandler?: (payload: IToolkitFormState) => void
}

export interface IToolkitFormState {
  name: string;
  company: string,
  email: string,
  position: string,
  reason: string
  optin: string,
  validEmail: boolean,
  loading: boolean;
}

enum ActionKind {
  UPDATE = "UPDATE",
  RESET = "RESET",
  LOADING = "LOADING",
  LOADING_STOP = "LOADING_STOP"
}

interface IAction {
  type: ActionKind;
  payload?: {
    name: string;
    value: string | number | boolean;
  };
}

const initialState: IToolkitFormState = {
  name: "",
  company: "",
  email: "",
  position: "",
  reason: "toolkit",
  optin: "yes",
  validEmail: true,
  loading: false
};

const formReducer = (state: IToolkitFormState, action: IAction): IToolkitFormState => {
  const { type, payload } = action;

  switch (type) {
    case ActionKind.UPDATE:
      return {
        ...state,
        [payload?.name || ""]: payload?.value
      }
    
    case ActionKind.RESET:
      return {
        ...state,
        ...initialState
      }
    case ActionKind.LOADING:
      return {
        ...state,
        loading: true
      }
    case ActionKind.LOADING_STOP:
      return {
        ...state,
        loading: false
      }

    default:
      return state;
  }
}


const ToolkitForm: React.FC<ToolkitFormProps> = ({onSubmitHandler})=>{  
  const [state, dispatch] = useReducer(formReducer, initialState);
  const { saveUser }  = useUserActions();

  const handleSubmit = () => {
    const isValidEmail = validateEmail(state.email);

    dispatch({
      type: ActionKind.UPDATE,
      payload: {
        name: "validEmail",
        value: isValidEmail
      }
    });    

    if( isValidEmail && state.name && state.company && state.email && state.position && state.optin) {

      try {
        dispatch({ type: ActionKind.LOADING });
        saveUser(state);

        var xhr = new XMLHttpRequest();
        xhr.open("POST", 'https://www.fullstoryinitiative.com/.netlify/functions/subscribe', true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function() {
          if(this.status === 200) {
            if (this.readyState === 4) {
              localStorage.setItem("subscribed", "yes");
              dispatch({ type: ActionKind.LOADING });

              if(onSubmitHandler){
                onSubmitHandler(state);
              } else{
                alert("needs submit handler")
              }
            }
          }
          else {
            alert("Sorry, we're having trouble signing you up");
          }
        }
        xhr.send(JSON.stringify({
          name: state.name,
          email: state.email,
          company: state.company,
          title: state.position,
          optin: state.optin,
          reason: state.reason
        }));
      }
      catch (err) {
        console.log('subscription error: ', err);
        dispatch({ type: ActionKind.LOADING_STOP });
      }

    } else{
      dispatch({ type: ActionKind.LOADING_STOP });
      alert("Please fill out all of the fields");
    }

  }

  const handleInputChange = (e:React.ChangeEvent<HTMLInputElement>, data: InputProps )=>{
    dispatch({
      type: ActionKind.UPDATE,
      payload: {
        name: data.name,
        value: data.value
      }
    })
  }

  const handleEmailChange = (e:React.ChangeEvent<HTMLInputElement>, data: InputProps )=>{
    dispatch({
      type: ActionKind.UPDATE,
      payload: {
        name: "validEmail",
        value: true
      }
    });//only prompt user if email is valid at submit
    handleInputChange(e, data);
  }

  const handleCheckboxChange = (e: React.FormEvent<HTMLInputElement>, data: CheckboxProps  )=>{
    dispatch({
      type: ActionKind.UPDATE,
      payload: {
        name: data.name as string,
        value: data.value as string
      }
    });
  }

  return(
    <ToolkitFormContainer>
      <Form className="toolkitForm" onSubmit={handleSubmit}>
        <Header as="h1" className="formSectionTitle" content="Please Fill Out" />
        
        <Form.Input placeholder="Name" name="name" aria-label="Full name" value={state.name} onChange={handleInputChange} />
        <Form.Input placeholder="Organization/Company" name="company" aria-label="Company" onChange={handleInputChange} />
        <Form.Input type="email" placeholder="Email" name="email" aria-label="Email Address"onChange={handleEmailChange} 
          error={ state.validEmail ? false :'Please enter a valid email address'}
        />
        
        <Header as="h1" className="formSectionTitle" content="Please Select" />
        
        <div className="positionFields">
          <Form.Radio name="position" label="Director" value="director" aria-label="Position: Director" onChange={handleCheckboxChange} checked={state.position === "director"}/>
          <Form.Radio name="position" label="Producer" value="producer" aria-label="Position: Producer" onChange={handleCheckboxChange} checked={state.position === "producer"}/>
          <Form.Radio name="position" label="Studio/Network Executive" aria-label="Position: Studio/Network Executive" onChange={handleCheckboxChange} value="studio/network executive" checked={state.position === "studio/network executive"}/>
          <Form.Radio name="position" label="Non-Profit Leader" aria-label="Position: Non-Profit Leader" onChange={handleCheckboxChange} value="non-profit leader" checked={state.position === "non-profit leader"}/>
          <Form.Radio name="position" label="Other" value="other" aria-label="Position: Other" onChange={handleCheckboxChange} checked={state.position === "other"}/>
        </div>

        <div className="signUpFields">
          <p>Would you like to receive emails with updates and announcements from the Full Story Initiative?</p>
          <Form.Radio name="optin" label="Yes!" value="yes" aria-label="Opt-in to Emails - Yes" onChange={handleCheckboxChange} checked={state.optin === "yes"}/>
          <Form.Radio name="optin" label="No, thank you" value="no" aria-label="Do not opt-in to Emails" onChange={handleCheckboxChange} checked={state.optin === "no"}/>
        </div>
        
        <Form.Button loading={state.loading} size="large" className="submitBtn" type="submit" content="Submit" aria-label="Submit Form" />
      </Form>

    </ToolkitFormContainer>
  );
}

export default ToolkitForm;